// extracted by mini-css-extract-plugin
module.exports = {"form":"health_form__2UFcQ","tip":"health_tip__1omzB","buttonMain":"health_buttonMain__F3FBq","videoList":"health_videoList__CODXr","contentMain":"health_contentMain__Oz2DJ"};